import React, { useContext, useState } from "react";
import AppContext from "@/modules/storefront/hooks/appContext";
import logo from "../../../assets/img/logo.svg";
import squadMini from "../../../assets/img/squad-mini.svg";
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import styles from "./styles.module.scss";
import Image from 'next/image';

const FrontHeader = () => {
  const {
    cart,
    storeName,
    storeLogo,
    currentCurrency,
    chooseCurrency,
    toggleCartModal,
  } = useContext(AppContext);

  const [openCurrencySelect, setOpenCurrencySelect] = useState(false);
  const [logoError, setLogoError] = useState(false);

  const handleLogoError = () => {
    setLogoError(true);
  };

  const handleImageError = (event) => {
    event.target.style.display = 'none'; 
  };

  const attemptRenderImg = (url) => {
    console.log(url.src);
    let attempt = <img src={url} />
    console.log(typeof attempt);
  }

  const setStoreCurrency = (currencyCode) => {
    chooseCurrency(currencyCode);
    setOpenCurrencySelect(false);
  }

  return (
    <>
      <div className={styles.header}>
        <div className={styles.container}>
          <div className={styles['header-content']}>
            <div className={styles['header-top']}>
              <div className={styles['nav-content']}>
              </div>
            </div>

            <div className={styles['title-box']}>
              <div className={styles['title-box-1']}>
                {
                  storeName ?
                    <>
                      <div className={styles['logo-space']}></div>
                      <div className={styles['mobile-logo-name']}>

                        {
                          storeLogo ?
                            <Image
                              src={storeLogo}
                              // src="https://picsum.photos/400"
                              alt="logo"
                              onError={(e) => handleImageError(e)}
                              layout="fill"
                            />
                            :
                            null
                        }
        
                        <div className={styles['store-name']}>{storeName}</div>
                      </div>
                    </>
                    :
                    <div className={styles['header-logo']}>
                      <div className={styles['logo-box']}>
                        <div className={styles['logo-bottom']}>
                          <Image
                            src={logo}
                            alt="logo"
                            className={styles['squad-logo']}
                          />
                        </div>
                      </div>
                    </div>
                }
              </div>

              <div className={styles['name-cart']}>
                {
                  storeLogo &&
                  <Image
                    src={storeLogo}
                    // src="https://picsum.photos/400"
                    alt="logo"
                    onError={(e) => handleImageError(e)}
                    layout="fill"
                  />
                }
                <div className={styles['store-name']}>{storeName}</div>
              </div>

              <div className={styles['title-box-3']}>
                <a href="https://dashboard.squadco.com/sign-up">
                  <button className={styles['btn-setup-store']}>Set Up Your Store For Free</button>
                </a>

                <div className={styles['currency-dropdown']}>
                  <div className={styles['currency-box']} onClick={() => setOpenCurrencySelect(!openCurrencySelect)}>
                    <div className={styles['currency-code']}>{currentCurrency}</div> <ExpandMoreRoundedIcon />
                  </div>

                  {
                    openCurrencySelect &&
                    <div className={styles['currency-select']}>
                      <div className={styles['select-option']} onClick={() => setStoreCurrency("NGN")}>
                        NGN
                      </div>

                      <div className={styles['select-option']} onClick={() => setStoreCurrency("USD")}>
                        USD
                      </div>
                    </div>
                  }
                </div>

                <div className={styles['sub-cart']}>
                  <div className={styles['cart-icon-box']} onClick={toggleCartModal}>
                    <ShoppingCartOutlinedIcon className={styles['cart-icon']} /> Cart
                    <div className={styles['cart-count']}>{cart.length}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default FrontHeader;